import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'

const AppFeature = () => {
   const [visible, setVisible] = useState(false)
   const containerRef = useRef(null)

   useEffect(() => {
      const observer = new IntersectionObserver(
         ([entry]) => {
            if (entry.isIntersecting) {
               setVisible(true)
            } else {
               setVisible(false)
            }
         },
         {
            threshold: 0.2,
            rootMargin: '0px'
         }
      )

      if (containerRef.current) {
         observer.observe(containerRef.current)
      }

      return () => {
         if (containerRef.current) {
            observer.disconnect()
         }
      }
   }, [])

   return (
      <div className="w-full h-full bg-white/10" ref={containerRef}>
         <div
            className={classNames(
               'absolute top-[15%] left-[10%] w-[80%] sm:left-[15%] sm:w-[70%]'
            )}>
            <div className="flex flex-col gap-4">
               <div
                  className={classNames(
                     'rounded-2xl overflow-hidden border border-solid border-zinc-50/5 shadow-[0px_0px_60px_rgba(0,0,0,0.9)] transition-all duration-[2000ms]',
                     visible ? '-translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                  )}>
                  <img
                     className="w-full"
                     src="/assets/custom/communities/images/features/app/1.jpg"
                     alt="Communities App"
                  />
               </div>
            </div>
         </div>
      </div>
   )
}

export default AppFeature
